import React from "react";
import DashboardOtherServicesWeekly from "./DashboardOtherServicesWeekly";

const DashboardV2OtherServicesWeekly = ({ user }) => (
  <DashboardOtherServicesWeekly user={user} />
);

export default DashboardV2OtherServicesWeekly;
